import React, { Component } from "react";
import Menu from "@material-ui/core/Menu";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import ReactDOM from "react-dom";
import { withTranslation } from "react-i18next";
import Typography from "@material-ui/core/Typography";
import { connect } from "react-redux";

export class ButtonMenu extends Component {
  constructor(props) {
    super(props);
    this.layoutMenuRef = React.createRef();

    this.state = {
      layoutMenuAnchor: null,
    };
    this.toggleMenu = this.toggleMenu.bind(this);
  }
  componentDidMount() {
    if (this.props.open) {
      this.setState({
        layoutMenuAnchor: ReactDOM.findDOMNode(this.layoutMenuRef.current),
      });
    }
  }
  componentDidUpdate(prevProps) {
    if (
      prevProps.open !== this.props.open &&
      typeof this.props.open !== "undefined"
    ) {
      if (this.props.open) {
        this.setState({
          layoutMenuAnchor: ReactDOM.findDOMNode(this.layoutMenuRef.current),
        });
      } else {
        this.setState({ layoutMenuAnchor: null });
      }
    }
  }
  render() {
    const { t } = this.props;
    return (
      <div aria-label="Options">
        <Tooltip title={<Typography>{t("global_options")}</Typography>}>
          <IconButton
            // aria-label={`options ${this.props.title}`}
            ref={this.layoutMenuRef}
            color="inherit"
            aria-owns={this.state.layoutMenuAnchor ? "layout-menu" : undefined}
            aria-label={this.props.ariaLabel}
            onClick={!this.props.isMobile && this.toggleMenu}
            onPointerDown={this.props.isMobile && this.toggleMenu}
          >
            <MoreVertIcon />
          </IconButton>
        </Tooltip>
        <Menu
          id="layout-menu"
          anchorEl={this.state.layoutMenuAnchor}
          open={Boolean(this.state.layoutMenuAnchor)}
          onClose={this.toggleMenu}
        >
          {this.props.children}
        </Menu>
      </div>
    );
  }

  toggleMenu = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (this.state.layoutMenuAnchor !== null && this.props.onClose) {
      return this.props.onClose();
    } else if (this.state.layoutMenuAnchor === null && this.props.onOpen) {
      return this.props.onOpen();
    }
    this.setState((prev) => {
      if (prev.layoutMenuAnchor !== null) {
        return { layoutMenuAnchor: null };
      }
      // findDOMNode is not ideal but I can't get this working without
      return {
        layoutMenuAnchor: ReactDOM.findDOMNode(this.layoutMenuRef.current),
      };
    });
  };
}
const mapStateToProps = (state) => ({
  isMobile: state.screen.isMobile,
});
const mapDispatchToProps = {};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(ButtonMenu));
